import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./PlantationOneOffer.scss";

import firebase from "firebase/app";
import "firebase/firestore";

import AddOffers from "../../../../default-hooks/AddOffers";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";

const PlantationOneOffer = () => {
  const { user } = useAuthContext();

  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const [offerTitle, setOfferTitle] = useState("Special Offers");
  const [editingTitle, setEditingTitle] = useState(false);
  const [newTitle, setNewTitle] = useState("");

  // Fetch Offers
  useEffect(() => {
    const db = firebase.firestore();

    const unsubscribeOffers = db
      .collection("offers")
      .orderBy("createdAt", "desc")
      .onSnapshot(
        (snapshot) => {
          const fetchedOffers = snapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((doc) => doc.imageURL);
          setOffers(fetchedOffers);
          setLoading(false);
        },
        (error) => {
          console.error("Firestore error:", error.message);
          setLoading(false);
        }
      );

    const unsubscribeTitle = db
      .collection("offers")
      .doc("header")
      .onSnapshot((doc) => {
        if (doc.exists) {
          setOfferTitle(doc.data().title || "Special Offers");
        }
      });

    return () => {
      unsubscribeOffers();
      unsubscribeTitle();
    };
  }, []);

  const saveTitle = async () => {
    try {
      const db = firebase.firestore();
      await db.collection("offers").doc("header").set({ title: newTitle });
      setEditingTitle(false);
    } catch (error) {
      console.error("Failed to update title:", error);
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const handleDeleteClick = (offerId) => {
    setDeleteTarget(offerId);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      const db = firebase.firestore();
      await db.collection("offers").doc(deleteTarget).delete();
      setDeleteTarget(null);
    } catch (error) {
      console.error("Error deleting offer:", error);
    } finally {
      setDeleting(false);
    }
  };

  const cancelDelete = () => {
    setDeleteTarget(null);
  };

  return (
    <section className="nature-offer-section">
      <div className="nature-text-center">
        {user?.role === "admin" && editingTitle ? (
          <div className="edit-title-box">
            <input
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
              placeholder="Enter new heading"
            />
            <button onClick={saveTitle}>Save</button>
            <button onClick={() => setEditingTitle(false)}>Cancel</button>
          </div>
        ) : (
          <h2 className="nature-heading nature-mb-2">
            {offerTitle}
            {user?.role === "admin" && (
              <button
  className="edit-title-btn"
  onClick={() => {
    setNewTitle(offerTitle);
    setEditingTitle(true);
  }}
>
  ✏️
</button>

              
            )}
          </h2>
        )}

        <div style={{ margin: "10px", textAlign: "right" }}>
          <AddOffers />
        </div>

        {loading ? (
          <p>Loading Offers...</p>
        ) : offers.length > 0 ? (
          <Slider {...settings}>
            {offers.slice(0, 3).map((offer, i) => (
              <div
                key={offer.id + i}
                className="offer-slide nature-mb-2"
                style={{ position: "relative" }}
              >
                <img
                  src={offer.imageURL}
                  alt={`Offer ${i + 1}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/img/default.jpg";
                  }}
                />

                {user?.role === "admin" && (
                  <div
                    className="delete-icon"
                    title="Delete Offer"
                    onClick={() => handleDeleteClick(offer.id)}
                  >
                    🗑️
                  </div>
                )}
              </div>
            ))}
          </Slider>
        ) : (
          <p>No offers available currently.</p>
        )}

        {deleteTarget && (
          <div className="delete-popup">
            <div className="popup-box">
              <p>Are you sure you want to delete this offer?</p>
              <div className="popup-buttons">
                <button
                  onClick={confirmDelete}
                  disabled={deleting}
                  style={{ opacity: deleting ? 0.6 : 1 }}
                >
                  {deleting ? "Deleting..." : "Delete"}
                </button>
                <button onClick={cancelDelete} disabled={deleting}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PlantationOneOffer;
